module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ixp5p"))).then(() => parcelRequire('8rm4T'));